import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { User } from "../../services/UserService";
import { useEffect, useState } from "react";
import { UserRole } from "../../enums/UserRole";
import authApi from "../../services/api/auth";
import styles from './CadastraUsuario.module.css'
import { Botao } from "@/components/Botao";
import { usuarioApi } from "@/services/api/usuario";
import { MuiTelInput } from "mui-tel-input";
import { commonInputStyles } from "../home/Components/TextField/TextField";

interface CadastraUsuarioProps {
    onCadastroOuAtualizacaoRealizado: (retorno: string) => void
    atualizar?: boolean,
    usuarioId?: string | number
}

export function CadastraUsuario({ onCadastroOuAtualizacaoRealizado, atualizar, usuarioId }: CadastraUsuarioProps) {
    const [usuario, setUsuario] = useState<User & { senha?: string }>({
        email: '',
        nome: undefined,
        telefone: `+55`,
        papel: [],
        userId: undefined,
        senha: undefined
    })
    const [senhaAtual, setSenhaAtual] = useState<string>()
    const [erro, setErro] = useState<string | null>(null);

    useEffect(() => {
        if (atualizar) {
            async function buscarUsuario() {
                if (usuarioId) {
                    const response = await usuarioApi.buscarUsuarioPorId(usuarioId)
                    if (response.status === 200) {
                        setUsuario(response.data)
                        setSenhaAtual(response.data.senha)
                    }
                }
            }
            buscarUsuario()
        }

    }, [atualizar, usuarioId])

    function ouvirDadosDoUsuario(info: { email?: string; nome?: string; telefone?: string; senha?: string; papel?: UserRole }) {
        setUsuario(prevUser => ({
            ...prevUser,
            email: info.email !== undefined ? info.email : prevUser.email,
            nome: info.nome !== undefined ? info.nome : prevUser.nome,
            telefone: info.telefone !== undefined ? info.telefone : prevUser.telefone,
            senha: info.senha !== undefined ? info.senha : prevUser.senha,
            papel: info.papel === UserRole.ATENDENTE
                ? [UserRole.ATENDENTE, UserRole.PROJETISTA]
                : info.papel === UserRole.PROJETISTA
                    ? [UserRole.PROJETISTA, UserRole.ATENDENTE]
                    : info.papel
                        ? [info.papel]
                        : prevUser.papel
        }));
    }

    function realizarEvento(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        if (atualizar && usuarioId) {
            if (usuario.senha === senhaAtual) {
                delete usuario.senha
            }
            const atualizarUsuario = usuarioApi.atualizarUsuario(usuarioId, usuario);
            atualizarUsuario.then(response => {
                if (response.status === 201) {
                    onCadastroOuAtualizacaoRealizado('atualizado')
                    setErro(null);
                } else {
                    onCadastroOuAtualizacaoRealizado('erro atualizar');
                }
            }).catch(error => {
                console.error("Erro ao atualizar usuário:", error);
                setErro(error.data.message);
            });
        } else {
            authApi.createUser(usuario).then(response => {
                if (response.status === 200 || response.status === 201) {
                    onCadastroOuAtualizacaoRealizado('cadastrado')
                } else {
                    onCadastroOuAtualizacaoRealizado('erro')
                }
            }).catch(error => {
                console.error("Erro ao atualizar usuário:", error);
                setErro(error.data.message);
            });
        }
    }

    return (
        <div>
            <form onSubmit={realizarEvento} className={styles.container_formulario}>
                <TextField
                    label="Nome"
                    value={usuario?.nome ?? ""}
                    onChange={(e) => { ouvirDadosDoUsuario({ nome: e.target.value }) }}
                    sx={{ height: '3.5rem' }}
                ></TextField>
                <TextField
                    label="E-mail"
                    value={usuario?.email ?? ""}
                    onChange={(e) => { ouvirDadosDoUsuario({ email: e.target.value }) }}
                    sx={{ height: '3.5rem' }}
                ></TextField>
                <MuiTelInput
                    label="Telefone"
                    name="telefone"
                    value={usuario?.telefone ?? ""}
                    onChange={(value: string) => {
                        ouvirDadosDoUsuario({ telefone: value });
                    }}
                    InputLabelProps={{
                        style: commonInputStyles,
                    }}
                    fullWidth
                />
                <FormControl fullWidth>
                    <InputLabel id="role-select-id">Role</InputLabel>
                    <Select
                        labelId="role-select-id"
                        label="Papel"
                        value={usuario.papel && usuario.papel.length > 0 ? usuario.papel[0] : "ADMIN"}
                        onChange={(e) => { ouvirDadosDoUsuario({ papel: e.target.value as UserRole ?? "ADMIN" }) }}
                    >
                        <MenuItem value="ADMIN">Administrador</MenuItem>
                        <MenuItem value="PROJETISTA">Projetista</MenuItem>
                        <MenuItem value="MONTADOR">Montador</MenuItem>
                        <MenuItem value="ATENDENTE">Atendente</MenuItem>
                    </Select>
                </FormControl>
                <TextField
                    type="password"
                    label="Senha"
                    value={usuario?.senha ?? ""}
                    onChange={(e) => { ouvirDadosDoUsuario({ senha: e.target.value }) }}
                ></TextField>
                {erro && <span style={{ color: 'red', marginTop: '1rem' }}>{erro}</span>}

                <Botao
                    tipo="submit"
                    texto={atualizar ? "ATUALIZAR USUÁRIO" : "CADASTRAR USUÁRIO"}
                    cor="#F7F7F9"
                    corDeFundo="#666CFF"
                    largura="23rem"
                />
            </form >
        </div >
    )
}
